const PRE_FIX_LOCAL_DATA = 'Boxsuit-user:'

export const saveLocalStorage = (key, value) => {
  localStorage.setItem(`${PRE_FIX_LOCAL_DATA}${key}`, value)
}

export const getLocalStorage = key => localStorage.getItem(`${PRE_FIX_LOCAL_DATA}${key}`)

export const removeLocalStorage = key => localStorage.removeItem(`${PRE_FIX_LOCAL_DATA}${key}`)

export const getAccessToken = () => getLocalStorage('accessToken')

export const getRefreshToken = () => getLocalStorage('refreshToken')

export const setAccessToken = (value) => {
  saveLocalStorage('accessToken', value)
}

export const removeAccessToken = () => {
  removeLocalStorage('accessToken')
}

export const setRefreshToken = (value) => {
  saveLocalStorage('refreshToken', value)
}

export const removeRefreshToken = () => {
  removeLocalStorage('refreshToken')
}



// WEBPACK FOOTER //
// ./src/utils/local-data-service.js